import { AccessGrant, VisitorGroup } from 'graphql/generated/graphqlTypes';
import { visitorsGroupsWithAccessGrantsVar } from 'state/vars';

export const setVisitorGroupsWithAccessGrantsAction = (visitorsGroupsWithAccessGrants: VisitorGroup[]) => {
  visitorsGroupsWithAccessGrantsVar(visitorsGroupsWithAccessGrants);
};

const updateAccessGrant = (visitorGroup: VisitorGroup, updatedAccessGrant: AccessGrant) =>
  visitorGroup.accessGrants.map((accessGrant) => {
    if (accessGrant.id === updatedAccessGrant.id) {
      return { ...accessGrant, doors: updatedAccessGrant.doors, locations: updatedAccessGrant.locations };
    }
    return accessGrant;
  });

export const updateToAccessGrantsAction = (updatedAccessGrant: AccessGrant) => {
  const currentVisitorGroups = visitorsGroupsWithAccessGrantsVar();
  const updatedVisitorGroups = currentVisitorGroups.map((visitorGroup) => ({
    ...visitorGroup,
    accessGrants: updateAccessGrant(visitorGroup, updatedAccessGrant)
  }));

  visitorsGroupsWithAccessGrantsVar(updatedVisitorGroups);
};
